import {useMutation} from "@tanstack/react-query";
import {notificationsApiClient} from "@/Service/Api/V1/ApiClients/NotificationsApiClient";
import {processRateLimiterErrors} from "@/Util/Api/processRateLimiterErrors";

export const useMarkAllNotificationsAsRead = () => useMutation({
    mutationFn: async () => {
        try {
            return await notificationsApiClient.markAllNotificationsAsRead()
        } catch (error) {
            await processRateLimiterErrors(error);
            throw error;
        }
    },
});
